import React from 'react';
import PlusComponent from "../../myComp/PlusComponent";
import ContentView from "../../myComp/ContentView";

class MaterialList extends PlusComponent {
  constructor(props) {
    super(props, "contentMaterial");         
  }

  render(){     
    return (
        <div>
          <ContentView {...this.props} title="Materiale" controller="contentMaterial"></ContentView>
        </div>
      )
    }
}

export default MaterialList;